@if (state) {
  <div class="absolute h-48 w-8 m-auto inset-0 z-999">
    <mat-spinner [diameter]="60"></mat-spinner>
  </div>
}
